import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Paper from 'material-ui/Paper';
import { ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import { Link } from 'react-router';
import { AdTypePicker, PageHeader, SelectableList, SecondaryButton } from 'components';
import { setAdType, getPageConnectedInstagramAccount, initAdBuilderForOrg, changeAdBuilderValue } from 'redux/modules/adBuilder';
import { connect } from 'react-redux';
import cookie from 'js-cookie';
import * as styles from './AdBuilder.scss';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import moment from 'moment';
var AdStep1 = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    user: state.auth.user,
    organization: state.organization.current,
    theme: state.theme,
    adBuilder: state.adBuilder["".concat(orgId)],
    adType: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    adAccountConnectedInstagramId: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adAccountConnectedInstagramId : null,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null
  };
}, {
  setAdType: setAdType,
  getPageConnectedInstagramAccount: getPageConnectedInstagramAccount,
  initAdBuilderForOrg: initAdBuilderForOrg,
  changeAdBuilderValue: changeAdBuilderValue
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdStep1, _Component);

  var _super = _createSuper(AdStep1);

  function AdStep1(props) {
    var _this;

    _classCallCheck(this, AdStep1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleListChange", function (val) {
      _this.props.setAdType(val, _this.props.organization.id);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMainContent", function () {
      return /*#__PURE__*/React.createElement(AdTypePicker, null);
    });

    _this.state = {
      selectedIndex: 6
    };
    return _this;
  }

  _createClass(AdStep1, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.getPageConnectedInstagramAccount(this.props.organization.id, this.props.adAccount.socialAccountId);
      this.props.initAdBuilderForOrg(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var theme = this.props.theme;
      var listItemStyle = {
        paddingBottom: 8,
        paddingTop: 6,
        paddingLeft: 8
      };
      var isSMB = this.props.organization.organizationTypeId === 3 && !this.props.user.isPartner;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Ad Builder - Select Ad Goal"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid #f1f1f1',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          minWidth: 290,
          overflow: 'hidden',
          overflowY: 'auto',
          flex: '0 0 290px'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectableList, {
        selectedIndex: this.props.adType,
        style: {
          padding: 0
        },
        onChange: this.handleListChange
      }, /*#__PURE__*/React.createElement(ListItem, {
        primaryText: "Page Likes",
        style: listItemStyle,
        value: "pageLikes",
        leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
          backgroundColor: theme.colors.gray3,
          icon: /*#__PURE__*/React.createElement("i", {
            className: "fa fa-thumbs-o-up ".concat(styles.avatarIcon)
          })
        })
      }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ListItem, {
        primaryText: "Website Clicks",
        style: listItemStyle,
        value: "clicksToWebsite",
        leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
          backgroundColor: theme.colors.gray3,
          icon: /*#__PURE__*/React.createElement("i", {
            className: "fa fa-mouse-pointer ".concat(styles.avatarIcon)
          })
        })
      }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ListItem, {
        primaryText: "Lead Generation",
        style: listItemStyle,
        value: "leadGeneration",
        leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
          backgroundColor: theme.colors.gray3,
          icon: /*#__PURE__*/React.createElement("i", {
            className: "icon ion-funnel ".concat(styles.avatarIcon)
          })
        })
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          overflow: 'hidden',
          overflowY: 'auto',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.mainArea
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Select Ad Goal"
      }), this.renderMainContent(), !isSMB && /*#__PURE__*/React.createElement(Link, {
        to: {
          pathname: "/org/".concat(this.props.organization.id, "/create-ad/2"),
          state: {
            modal: false,
            returnTo: "/org/".concat(this.props.organization.id, "/ads")
          }
        }
      }, /*#__PURE__*/React.createElement(SecondaryButton, {
        onClick: function onClick() {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            step: 2
          });
        },
        label: "Select"
      })), isSMB && /*#__PURE__*/React.createElement(Paper, {
        style: {
          display: 'inline-block',
          padding: 12
        },
        zDepth: 1
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          lineHeight: '18px'
        }
      }, "Contact us to create a new ad.", /*#__PURE__*/React.createElement("br", null), "212-359-4355", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
        href: "mailto:contact@likeablelocal.com"
      }, "contact@likeablelocal.com"))))))));
    }
  }]);

  return AdStep1;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired,
  adType: PropTypes.string.isRequired,
  setAdType: PropTypes.func.isRequired
}), _temp)) || _class);
export default AdStep1;